import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { fromFetch } from 'rxjs/fetch';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  getTranslation(lang: string) {
    return fromFetch<Translation>(
      new Request(`/assets/i18n/${lang}.json`, {
        method: 'GET',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
      }),
      {
        selector: async (response) => response.json() as Promise<Translation>,
      }
    );
  }
}
